import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { api, type Overview, type UserItem, type UserRow } from "../api";

export function Users() {
  const [users, setUsers] = useState<UserRow[]>();
  const [admins, setAdmins] = useState<string[]>([]);
  const [err, setErr] = useState("");
  const nav = useNavigate();
  useEffect(() => {
    api<{ users: UserRow[] }>("/admin/users").then((r) => setUsers(r.users)).catch((e: Error) => setErr(e.message));
    api<Overview>("/admin/overview").then((o) => setAdmins(o.admins ?? [])).catch(() => {});
  }, []);
  if (err) return <div className="msg err">{err}</div>;
  if (!users) return <p className="chrome">Loading…</p>;
  return (
    <>
      <h2>Users</h2>
      <p className="sub">{users.length} signed in with Google. Guests never appear here — they exist only as anonymous ids in events. Admins: {admins.join(", ") || "none configured"}.</p>
      <table className="tbl">
        <thead><tr><th>User</th><th>Topics</th><th className="num">Saved</th><th className="num">Seen</th><th>Last seen</th><th>Joined</th></tr></thead>
        <tbody>
          {users.length === 0 && <tr><td colSpan={6} className="chrome">No users yet.</td></tr>}
          {users.map((u) => (
            <tr key={u.sub} className="link" onClick={() => nav(`/admin/users/${u.sub}`)}>
              <td>{u.name ?? "—"}{u.email && admins.includes(u.email.toLowerCase()) && <> <span className="pill approved">admin</span></>}<br /><span className="chrome">{u.email ?? u.sub}</span></td>
              <td>{u.prefs.topics.join(", ") || <span className="chrome">none</span>}</td>
              <td className="num">{u.saved}</td><td className="num">{u.seen}</td>
              <td>{u.lastSeenAt?.slice(0, 10)}</td><td>{u.createdAt?.slice(0, 10)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export function UserDetail() {
  const { sub = "" } = useParams();
  const [u, setU] = useState<UserRow & { items: UserItem[] }>();
  const [err, setErr] = useState("");
  const nav = useNavigate();
  useEffect(() => { api<UserRow & { items: UserItem[] }>(`/admin/users/${sub}`).then(setU).catch((e: Error) => setErr(e.message)); }, [sub]);
  if (err) return <div className="msg err">{err}</div>;
  if (!u) return <p className="chrome">Loading…</p>;
  const del = async () => {
    if (!confirm(`Delete ${u.email ?? u.sub}'s profile, saved chains and preferences? This cannot be undone.`)) return;
    await api(`/admin/users/${sub}`, { method: "DELETE" });
    nav("/admin/users");
  };
  return (
    <>
      <p className="chrome"><Link to="/admin/users">← Users</Link></p>
      <h2>{u.name ?? u.email ?? u.sub}</h2>
      <p className="sub">{u.email} · joined {u.createdAt?.slice(0, 10)} · last seen {u.lastSeenAt?.slice(0, 10)} · topics: {u.prefs.topics.join(", ") || "none"}</p>
      <table className="tbl">
        <thead><tr><th>Chain</th><th>Saved</th><th>Seen</th><th>Updated</th></tr></thead>
        <tbody>
          {u.items.map((i) => <tr key={i.spreadId}><td><Link to={`/admin/spreads/${i.spreadId}`}>{i.spreadId}</Link></td><td>{i.saved ? "yes" : ""}</td><td>{i.seenAt?.slice(0, 10) ?? ""}</td><td>{i.updatedAt?.slice(0, 16).replace("T", " ")}</td></tr>)}
          {u.items.length === 0 && <tr><td colSpan={4} className="chrome">Nothing yet.</td></tr>}
        </tbody>
      </table>
      <button className="btn danger" style={{ marginTop: 24 }} onClick={del}>Delete this user's data</button>
    </>
  );
}
